import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 20,
    },
    billTo: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
});



const BillRecever = ({buyer}) => {
   return (<View style={styles.headerContainer}>
        <Text style={styles.billTo}>Bill To:</Text>
        <Text style={{ marginBottom: "3px", fontSize:13 }}>{buyer?.buyerName}</Text>
        <Text>{buyer?.address}</Text>
    </View>)
};

export default BillRecever